<template>
  <div class="page process-instance-page" :class="{'page__has-task':instance.task && instance.task.ruleNodeType==1}">
    <div v-if="instance.companyName" class="process-instance-top">
      <p class="tag-warn">{{instance.companyName}}</p>
    </div>
    <div v-if="instance.latestId&&instance.id!=instance.latestId" class="process-instance-top">
      <p class="tag-warn">
        <span>当前流程已经被{{instance.operation==2?'驳回':(instance.operation==4?'反提交':'重新提交')}}，</span>
        <a href="javascript:;" @click="getData(instance.latestId)">点击查看最新流程</a>
      </p>
    </div>
    <div v-else-if="instance.operation==2||instance.operation==4" class="process-instance-top">
      <p class="tag-warn">
        当前流程已经被{{instance.operation==2?'驳回':'反提交'}}
      </p>
    </div>

    <div v-if="instance.warnMessage" class="process-instance-top">
      <p class="tag-warn">智能提示：{{instance.warnMessage}}</p>
    </div>
    
    <biz-viewer v-if="instance" class="bill-block" :biz="instance" />

    <collapse v-if="tasks" class="timeline-collapse" :title="prevTasks ? '当前流程信息' : '流程信息'">
      <div class="timeline-container">
        <timeline :groups="tasks"></timeline>
      </div>
    </collapse>

    <collapse v-if="prevTasks" class="timeline-collapse" title="上次流程信息">
      <div class="timeline-container">
        <timeline :groups="prevTasks"></timeline>
      </div>
    </collapse>

    <div class="task-block" v-if="instance.task && instance.task.ruleNodeType==1">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <textarea
              class="weui-textarea"
              placeholder="填写审批意见"
              rows="2"
              v-model="comment"
              maxlength="100"
          ></textarea>
          <div class="weui-textarea-counter">
            <span>{{comment?comment.length:0}}</span>/100
          </div>
        </div>
      </div>
    </div>
    <div class="status-block" v-if="instance.status==2" :class="getApprovalStatus()"></div>
    <div class="footer-bar weui-dialog__ft" v-if="instance.task && instance.task.ruleNodeType==1">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="onApprove">同意</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="onReject"
      >驳回</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="showChangeDialog=true"
      >转审</a>
    </div>
    <div class="js_dialog" v-if="showRejectDialog">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">
          <textarea
            class="weui-textarea"
            placeholder="请输入您的理由"
            rows="2"
            v-model="comment"
            autofocus
          ></textarea>
        </div>
        <div class="weui-dialog__ft">
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click="showRejectDialog=false"
          >取消</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="onConfirmReject"
          >确定</a>
        </div>
      </div>
    </div>
    <div class="js_dialog" v-if="showChangeDialog">
      <div class="weui-mask"></div>
      <div class="weui-dialog" style="height:70%;display:flex;">
        <div class="weui-dialog__bd" style="flex:1;">
          <account-field label="选择处理人" v-model="changeHandler.realname" @select="selectAccount"></account-field>
          <textarea
            class="weui-textarea input-box"
            placeholder="请输入您的理由"
            rows="2"
            v-model="comment"
            autofocus
            style="flex:1;width:auto;"
          ></textarea>
        </div>
        <div class="weui-dialog__ft">
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click="showChangeDialog=false"
          >取消</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="onConfirmChange"
          >确定</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BizViewer from "@/components/BizViewer.vue";
import Timeline from "@/components/Timeline.vue";
import AccountField from "@/components/field/AccountField.vue";
import Collapse from "@/components/Collapse.vue";
import Session from '@/util/session';

export default {
  components: {
    BizViewer,
    Timeline,
    AccountField,
    Collapse
  },
  data() {
    return {
      showRejectDialog: false,
      showChangeDialog: false,
      comment: null,
      instance: {
        task: null
      },
      tasks: null,
      prevTasks: null,
      changeHandler: {
        realname: null
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData();
    });
  },
  beforeDestroy() {
    Session.setScopeCompany(null);
  },
  methods: {
    getData(id, prevOrNext) {
      var me = this;
      id = id || me.$route.params.id;
      var url = "/api/process/instance/read_biz/" + id;
      if (prevOrNext) {
        url += "/" + prevOrNext;
      }
      return me
        .$loading({
          url
        })
        .then(function(res) {
          if (res.success) {
            var instance = res.data;
            if (instance) {
              // 集团版，指定子账套
              if (instance.companyId) {
                Session.setScopeCompany(instance.companyId);
              }
              me.instance = instance;
              me.comment = null;
              me.tasks = me.getTimelineData(instance, instance.groups);
              if (instance.prevGroups && instance.prevGroups.length) {
                me.prevTasks = me.getTimelineData(instance.prevGroups[0].items[0], instance.prevGroups);
              } else {
                me.prevTasks = null;
              }
              me.changeHandler = {};
              document.title =
                instance.launcherName + "的" + instance.ruleName + "流程";
              if (prevOrNext) {
                if (window.uni) {
                  window.uni.postMessage({
                    data: {
                      action: "replaceUrl",
                      params: [window.location.pathname + decodeURIComponent(window.location.search), '/process/instance/' + instance.id]
                    }
                  });
                }
                me.$router.replace({
                  name: "ProcessInstance",
                  params: {
                    id: instance.id
                  }
                });
              }
            }
            return res;
          } else {
            me.$router.push({
              name: "Error",
              params: res
            });
          }
        });
    },
    getApprovalStatus() {
      var operation = this.instance.operation;
      if (operation == 2) {
        return "status-error";
      }
      if (operation == 1 || operation == 3) {
        return "status-success";
      }
      return null;
    },
    onApprove() {
      this.doApprove(true, this.comment || "");
    },
    onReject() {
      var me = this, comment = me.comment;
      if (!comment) {
        me.showRejectDialog = true;
      } else {
        me.doApprove(false, comment);
      }
    },
    onConfirmReject() {
      var me = this,
        comment = me.comment;
      if (!comment) {
        me.$weui.topTips("请填写驳回的原因", 3000);
      } else {
        me.showRejectDialog = false;
        me.doApprove(false, comment);
      }
    },
    onConfirmChange() {
      var me = this, instance = me.instance,
        id = instance.id,
        handler = me.changeHandler.id,
        reason = me.comment,
        itemId = instance.task.id,
        bizType = instance.bizType,
        bizId = instance.bizId;
      if (!handler) {
        me.$weui.topTips("请选择变更处理人", 3000);
      } else {
        me.showChangeDialog = false;
        me.$loading({
          method: "post",
          url: "/api/process/instance/change",
          params: {
            bizType,
            bizId,
            itemId,
            handler,
            reason
          }
        }).then(function(res) {
          if (res.success) {
            // 尝试打开下一条
            me.getData(id, "next").then(r => {
              if (!r.data) {
                me.getData(id);
                me.$weui.toast("操作成功", 2000);
              } else {
                me.$weui.toast("操作成功，进入下一条", 1000);
              }
            });
          } else {
            me.$router.push({
              name: "Error",
              params: res
            });
          }
        });
      }
    },
    doApprove(approved, comment) {
      var me = this, instance = me.instance,
        id =instance.id,
        itemId = instance.task.id,
        bizType = instance.bizType,
        bizId = instance.bizId;
      me.$loading({
        method: "post",
        url: `/api/process/instance/approve`,
        jsonData: {
          bizType,
          bizId,
          itemId,
          approved,
          comment
        }
      }).then(function(res) {
        if (res.success) {
          // 尝试打开下一条
          me.getData(id, "next").then(r => {
            if (!r.data) {
              me.getData(id);
              me.$weui.toast("操作成功", 2000);
            } else {
              me.$weui.toast("操作成功，进入下一条", 1000);
            }
          });
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    getTimelineData(start, groups) {
      var me = this,
        data = [
          {
            key: 0,
            type: "success",
            title: "发起",
            items: [
              {
                key: 0,
                type: "success",
                operator: start.launcherName,
                operatorId: start.launcherId,
                operation: "发起",
                time: start.launchTime
              }
            ]
          }
        ];
      if (groups) {
        groups.forEach(group => {
          if (group.items) {
            data.push({
              key: group.ruleNodeOrderNum,
              type: me.getActivityType(group),
              title: group.ruleNodeName,
              items: group.items.map(item => {
                return {
                  key: item.id,
                  type: me.getActivityType(item),
                  operator: item.handlerName,
                  operatorId: item.handlerId,
                  operation: me.getOperationName(item),
                  time: item.handleTime,
                  comment: item.comment,
                  remark: item.remark
                };
              })
            });
          }
        });
      }
      return data;
    },
    getActivityType(item) {
      if (item.status == 2) {
        // 已开始：待处理
        return "warning";
      } else if (item.status == 3) {
        // 已结束：同意 / 驳回 / 变更
        if (item.operation == 2 || item.operation == 6) {
          return "error";
        } else if (item.operation == 3) {
          return "warning";
        }
        return "success";
      } else {
        // 未开始
        return "default";
      }
    },
    getOperationName(item) {
      var name = "";
      switch (item.operation) {
        case 0:
          name = item.status == 1
              ? "未开始"
              : item.ruleNodeType == 1
              ? "待处理"
              : "待阅读";
          break;
        case 1:
          name = "同意";
          break;
        case 2:
          name = "驳回";
          break;
        case 3:
          name = "变更";
          break;
        case 4:
          name = "浏览";
          break;
        case 5:
          name = "自动结束";
          break;
        case 6:
          name = "强制结束";
          break;
        default:
          name =
            item.status == 1
              ? "未开始"
              : item.ruleNodeType == 1
              ? "待审批"
              : "待阅读";
          break;
      }
      return name;
    },
    /**
     * 转审选人
     */
    selectAccount(account) {
      this.changeHandler = account;
    }
  }
};
</script>

<style>
.process-instance-page .bill-block > .page {
  position: inherit;
}
.process-instance-page .status-block {
  position: absolute;
  top: 30px;
  left: 100px;
  width: 60px;
  height: 60px;
}
.process-instance-page .status-error {
  background: url("../../assets/images/unapproved.png") 0 0 no-repeat;
  background-size: 60px 60px;
}
.process-instance-page .status-success {
  background: url("../../assets/images/approved.png") 0 0 no-repeat;
  background-size: 60px 60px;
}
.process-instance-page .task-block {
  /* background: #fff; */
  background-color: var(--weui-BG-2);
  padding: 10px 15px;
  margin-bottom: 48px;
}
.page__has-task .task-block {
  padding-bottom: 48px;
}
.process-instance-page .account-selector {
  text-align: left;
  padding: 10px 0;
  margin-bottom: 10px;
}
.process-instance-top {
  background: var(--weui-BG-2);
  padding: 10px 15px;
}

.process-instance-page .timeline-collapse {
  background-color: var(--weui-BG-2);
  margin-bottom: 10px;
}

.process-instance-page .timeline-container {
  padding: 16px;
}
</style>